var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.booking != null
      ? _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "dashboard-main-content" },
              [
                _c("v-app", [
                  _c(
                    "div",
                    { staticClass: "container-fluid" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-12" }, [
                          _c("div", { staticClass: "form-box" }, [
                            _c(
                              "div",
                              { staticClass: "form-content pb-2" },
                              [
                                _c("h3", { staticClass: "title mb-3" }, [
                                  _vm._v("Rezervasyon"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-auto" }, [
                                    _c(
                                      "span",
                                      { staticClass: "bookingNumberWrapper" },
                                      [
                                        _vm._v("Reservasyon Numarası : "),
                                        _c(
                                          "span",
                                          { staticClass: "bookingNumber" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.booking.bookingNumber)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-auto" }, [
                                    _c(
                                      "div",
                                      [
                                        _c("reservation-status", {
                                          attrs: {
                                            "booking-status":
                                              _vm.booking.bookingStatus,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                _vm.webUrl +
                                                "/web-api/booking/" +
                                                _vm.booking.ref +
                                                "/document/agreement?locale=" +
                                                _vm.locale,
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "theme-btn w-20",
                                                staticStyle: {
                                                  "line-height": "25px",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "las la-print",
                                                }),
                                                _vm._v(
                                                  "Rezervasyonu Yazdır\n                          "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                _vm.webUrl +
                                                "/web-api/booking/" +
                                                _vm.booking.ref +
                                                "/document/postPaymentConfirmation?locale=" +
                                                _vm.locale,
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "theme-btn w-20",
                                                staticStyle: {
                                                  "line-height": "25px",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "las la-print",
                                                }),
                                                _vm._v(
                                                  "Ödeme Belgesi Yazdır\n                          "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.projectName === "miray"
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    _vm.webUrl +
                                                    "/web-api/booking/" +
                                                    _vm.booking.ref +
                                                    "/document/ship-ticket?locale=" +
                                                    _vm.locale,
                                                  target: "_blank",
                                                },
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "theme-btn w-20",
                                                    staticStyle: {
                                                      "line-height": "25px",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "las la-print",
                                                    }),
                                                    _vm._v(
                                                      "Gemi bileti yazdır\n                          "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col d-flex align-items-center justify-content-end",
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "theme-btn w-20",
                                          staticStyle: {
                                            "line-height": "25px",
                                          },
                                          on: {
                                            click: _vm.openReservationLogs,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "las la-history",
                                          }),
                                          _vm._v(
                                            "Rezervasyon Logları\n                        "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.booking.revisionBookingId != null &&
                                _vm.booking.revisionBookingId != 0
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "theme-btn theme-btn-small mb-2",
                                        on: {
                                          click: function ($event) {
                                            return _vm.goToVersion(
                                              _vm.booking.revisionBookingId
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Güncel Halini Görüntüle")]
                                    )
                                  : _vm.isBookingEditable()
                                  ? _c(
                                      "div",
                                      { staticClass: "btn-box pt-3 pb-4" },
                                      [
                                        !_vm.edit
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "theme-btn w-20",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.edit = true
                                                  },
                                                },
                                              },
                                              [_vm._v("Rezervasyon Güncelle")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.edit
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "cancel-btn w-20",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.edit = false
                                                  },
                                                },
                                              },
                                              [_vm._v("İptal")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.edit
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "theme-btn w-20",
                                                on: { click: _vm.check },
                                              },
                                              [_vm._v("Kaydet")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.edit
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "theme-btn w-20",
                                                on: {
                                                  click: _vm.showCancelPopup,
                                                },
                                              },
                                              [_vm._v("Rezervasyonu Iptal Et")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.edit
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "theme-btn w-20",
                                                on: {
                                                  click: _vm.showNoShowPopup,
                                                },
                                              },
                                              [_vm._v("NO SHOW")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.edit &&
                                        _vm.projectName === "selectum"
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "theme-btn w-20",
                                                on: {
                                                  click:
                                                    _vm.showComplimentaryPopup,
                                                },
                                              },
                                              [_vm._v("Complimentary")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.edit &&
                                        _vm.projectName === "selectum"
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "theme-btn w-20",
                                                on: {
                                                  click: _vm.downloadVisaKit,
                                                },
                                              },
                                              [_vm._v("Visa Kit")]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.historyList != null
                                  ? _c(
                                      "div",
                                      { staticClass: "row container" },
                                      _vm._l(
                                        _vm.historyList,
                                        function (historyBooking, index) {
                                          return _c(
                                            "div",
                                            {
                                              staticClass:
                                                "ml-2 mr-2 mt-2 mb-2",
                                            },
                                            [
                                              historyBooking.id != null
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "theme-btn theme-btn-small mb-2",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.goToVersion(
                                                            historyBooking.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Versiyon " +
                                                          _vm._s(
                                                            _vm.historyList
                                                              .length - index
                                                          )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("booking-payment-information"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "row justify-content-between",
                                  },
                                  [
                                    _c("div", { staticClass: "col-lg-6" }, [
                                      _c(
                                        "div",
                                        { staticClass: "card-item p-3" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "contact-form-action",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "input-box" },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "label-text",
                                                    },
                                                    [_vm._v("Tarih :")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.booking
                                                    .revisionBookingId != null
                                                    ? _c(
                                                        "span",
                                                        { staticClass: "text" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "ddMMyyyy"
                                                              )(
                                                                _vm.booking
                                                                  .createDate
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.booking
                                                    .revisionBookingId == null
                                                    ? _c(
                                                        "span",
                                                        { staticClass: "text" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "ddMMyyyy"
                                                              )(new Date())
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "input-box" },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "label-text",
                                                    },
                                                    [_vm._v("Acente :")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.agencyList != null &&
                                                  _vm.userListMap != null &&
                                                  _vm.userListMap[
                                                    _vm.booking.agentId
                                                  ] != null
                                                    ? _c(
                                                        "span",
                                                        { staticClass: "text" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.agencyMap[
                                                                _vm.userListMap[
                                                                  _vm.booking
                                                                    .agentId
                                                                ].agencyId
                                                              ].name
                                                            ) + " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.edit
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "input-box",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "label-text",
                                                        },
                                                        [_vm._v("User :")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.agencyList != null &&
                                                      _vm.userListMap != null &&
                                                      _vm.userListMap[
                                                        _vm.booking.agentId
                                                      ] != null
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .userListMap[
                                                                    _vm.booking
                                                                      .agentId
                                                                  ].email
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.edit
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "input-box",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "label-text",
                                                        },
                                                        [_vm._v("User :")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-app",
                                                        [
                                                          _c("v-autocomplete", {
                                                            attrs: {
                                                              filter:
                                                                _vm.filterUsersByEmail,
                                                              items:
                                                                _vm.userList,
                                                              flat: "",
                                                              "hide-no-data":
                                                                "",
                                                              "hide-details":
                                                                "",
                                                              "item-value":
                                                                "id",
                                                              placeholder:
                                                                "User",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "selection",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var item =
                                                                      ref.item
                                                                    var selected =
                                                                      ref.selected
                                                                    return [
                                                                      _vm._v(
                                                                        "\n                                  " +
                                                                          _vm._s(
                                                                            item.email
                                                                          ) +
                                                                          " - " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .agencyMap[
                                                                              item
                                                                                .agencyId
                                                                            ]
                                                                              .name
                                                                          ) +
                                                                          "\n                                "
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                                {
                                                                  key: "item",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var item =
                                                                      ref.item
                                                                    var tile =
                                                                      ref.tile
                                                                    return [
                                                                      _vm._v(
                                                                        "\n                                    " +
                                                                          _vm._s(
                                                                            item.email
                                                                          ) +
                                                                          " - " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .agencyMap[
                                                                              item
                                                                                .agencyId
                                                                            ]
                                                                              .name
                                                                          ) +
                                                                          "\n"
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              false,
                                                              1330735105
                                                            ),
                                                            model: {
                                                              value:
                                                                _vm.booking
                                                                  .agentId,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.booking,
                                                                    "agentId",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "booking.agentId",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    !_vm.edit
                                      ? _c("div", { staticClass: "col-lg-6" }, [
                                          _c(
                                            "div",
                                            { staticClass: "card-item p-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "contact-form-action",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "input-box",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "label-text",
                                                        },
                                                        [_vm._v("Adı :")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        { staticClass: "text" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.booking
                                                                .contactName
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "input-box",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "label-text",
                                                        },
                                                        [_vm._v("Email :")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        { staticClass: "text" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.booking
                                                                .contactEmail
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "input-box",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "label-text",
                                                        },
                                                        [_vm._v("Telefon : ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        { staticClass: "text" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.booking
                                                                .contactPhone
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "col-lg-6",
                                            staticStyle: {
                                              "max-height": "300px",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "card-item p-3" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "contact-form-action",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-box",
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "label-text",
                                                          },
                                                          [_vm._v("Sefer :")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.booking.sail
                                                                  .cruise.name
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-box",
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "label-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Kalkış Limanı :"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.booking.sail
                                                                  .routes[0]
                                                                  .port.name
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-box",
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "label-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Kalkış Tarihi : "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "ddMMyyyyHHmm"
                                                                )(
                                                                  _vm.booking
                                                                    .sail
                                                                    .sailDate
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _vm.edit
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "col-lg-6",
                                            staticStyle: {
                                              "max-height": "300px",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "card-item p-3" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "contact-form-action",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-box",
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "label-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Yatak seçimi :"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "base-select-input",
                                                          {
                                                            attrs: {
                                                              "option-list":
                                                                _vm.bedOptions,
                                                              rules: "required",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.booking
                                                                  .bedOption,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.booking,
                                                                    "bedOption",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "booking.bedOption",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.edit
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "col-lg-6",
                                            staticStyle: {
                                              "max-height": "300px",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "card-item p-3" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "contact-form-action",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-box",
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "label-text",
                                                          },
                                                          [_vm._v("Sefer :")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            items: _vm.sailList,
                                                            flat: "",
                                                            "hide-no-data": "",
                                                            "menu-props": {
                                                              nudgeTop: 110,
                                                              maxHeight: 175,
                                                            },
                                                            "hide-details": "",
                                                            "item-value": "id",
                                                            placeholder:
                                                              "Kabin",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "selection",
                                                                fn: function (
                                                                  ref
                                                                ) {
                                                                  var item =
                                                                    ref.item
                                                                  var selected =
                                                                    ref.selected
                                                                  return [
                                                                    _vm._v(
                                                                      "\n                                  " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "ddMMyyyy"
                                                                          )(
                                                                            item.sailDate
                                                                          )
                                                                        ) +
                                                                        "\n                                "
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                              {
                                                                key: "item",
                                                                fn: function (
                                                                  ref
                                                                ) {
                                                                  var item =
                                                                    ref.item
                                                                  var tile =
                                                                    ref.tile
                                                                  return [
                                                                    _c(
                                                                      "v-list-tile-content",
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                    " +
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "ddMMyyyy"
                                                                              )(
                                                                                item.sailDate
                                                                              )
                                                                            ) +
                                                                            "\n                                  "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            3114582482
                                                          ),
                                                          model: {
                                                            value:
                                                              _vm.booking.sail
                                                                .id,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.booking
                                                                  .sail,
                                                                "id",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "booking.sail.id",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.edit
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "col-lg-6 mb-10",
                                            staticStyle: {
                                              "max-height": "300px",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "card-item p-3" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "contact-form-action",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-box",
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "label-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Konaklama Tipi :"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "base-select-input",
                                                          {
                                                            attrs: {
                                                              "option-list":
                                                                _vm.accommodationTypes,
                                                              rules: "required",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.booking
                                                                  .accommodationType,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.booking,
                                                                    "accommodationType",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "booking.accommodationType",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("passenger-information-edit", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.edit,
                            expression: "!edit",
                          },
                        ],
                      }),
                      _vm._v(" "),
                      _c("passenger-information", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.edit,
                            expression: "edit",
                          },
                        ],
                        ref: "passengerInformation",
                      }),
                      _vm._v(" "),
                      !_vm.archived &&
                      _vm.booking.revisionBookingId != null &&
                      _vm.booking.revisionBookingId != 0
                        ? _c(
                            "a",
                            {
                              staticClass: "theme-btn theme-btn-small mb-2",
                              attrs: {
                                href:
                                  _vm.basePath +
                                  "/bookings/" +
                                  _vm.booking.revisionBookingId,
                              },
                            },
                            [_vm._v("Güncel Halini Görüntüle")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.archived &&
                      _vm.booking.revisionBookingId != null &&
                      _vm.booking.revisionBookingId != 0
                        ? _c(
                            "a",
                            {
                              staticClass: "theme-btn theme-btn-small mb-2",
                              attrs: {
                                href:
                                  _vm.basePath +
                                  "/bookings/archived/" +
                                  _vm.booking.revisionBookingId,
                              },
                            },
                            [_vm._v("Güncel Halini Görüntüle")]
                          )
                        : _vm.isBookingEditable()
                        ? _c("div", { staticClass: "btn-box pb-5" }, [
                            _vm.edit
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "cancel-btn w-20",
                                    on: {
                                      click: function ($event) {
                                        _vm.edit = false
                                      },
                                    },
                                  },
                                  [_vm._v("İptal")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.edit
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "theme-btn w-20",
                                    on: { click: _vm.check },
                                  },
                                  [_vm._v("Kaydet")]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("sail-detail-showcase", {
                        attrs: { sail: _vm.booking.sail },
                      }),
                      _vm._v(" "),
                      _c("payment-list"),
                      _vm._v(" "),
                      _c("refund-list"),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-4" },
                          [
                            _c("booking-notes", {
                              attrs: { title: "Genel Notlar", type: "general" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-4" },
                          [
                            _c("booking-notes", {
                              attrs: {
                                title: "Muhasebe Notları",
                                type: "accounting",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-4" },
                          [
                            _c("booking-notes", {
                              attrs: { title: "Sefer Notları", type: "sail" },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("check-change-popup"),
            _vm._v(" "),
            _c("remote-payment-popup"),
            _vm._v(" "),
            _c("create-refund-popup"),
            _vm._v(" "),
            _c("create-discount-popup"),
            _vm._v(" "),
            _c("create-penalty-popup"),
            _vm._v(" "),
            _c("cancel-booking-popup"),
            _vm._v(" "),
            _c("create-booking-note-popup"),
            _vm._v(" "),
            _c("booking-action-history"),
            _vm._v(" "),
            _c("no-show-booking-popup"),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }